module.exports = __webpack_public_path__ + "img/entrenamiento.4e46b047.png";